/* VikingsBrand Rune Tools — Translator + Bindrune Maker.
   Vanilla JS. Elder/Younger/Anglo maps, digraphs, reverse decode,
   multi-format multi-design poster downloads (canvas PNG), rune meanings legend,
   bindrune overlay, share card. No dependencies. Self-inits on DOMContentLoaded. */
(function () {
  'use strict';
  if (window.VBRunes) { return; } /* idempotent: never double-boot */

  /* ---- transliteration maps (verbatim) ---- */
  var MAPS = {
    elder: {
      map: { a:'ᚨ',b:'ᛒ',c:'ᚲ',d:'ᛞ',e:'ᛖ',f:'ᚠ',g:'ᚷ',h:'ᚺ',i:'ᛁ',j:'ᛃ',k:'ᚲ',l:'ᛚ',m:'ᛗ',n:'ᚾ',o:'ᛟ',p:'ᛈ',q:'ᚲ',r:'ᚱ',s:'ᛋ',t:'ᛏ',u:'ᚢ',v:'ᚹ',w:'ᚹ',x:'ᚲᛋ',y:'ᛃ',z:'ᛉ' },
      di: { th:'ᚦ', ng:'ᛜ' }, name: 'Elder Futhark', rev: { 'ᛃ':'y' },
      row: [['f','ᚠ'],['u','ᚢ'],['th','ᚦ'],['a','ᚨ'],['r','ᚱ'],['k','ᚲ'],['g','ᚷ'],['w','ᚹ'],['h','ᚺ'],['n','ᚾ'],['i','ᛁ'],['j','ᛃ'],['ï','ᛇ'],['p','ᛈ'],['z','ᛉ'],['s','ᛋ'],['t','ᛏ'],['b','ᛒ'],['e','ᛖ'],['m','ᛗ'],['l','ᛚ'],['ng','ᛜ'],['o','ᛟ'],['d','ᛞ']]
    },
    younger: {
      map: { a:'ᛅ',b:'ᛒ',c:'ᚴ',d:'ᛏ',e:'ᛁ',f:'ᚠ',g:'ᚴ',h:'ᚼ',i:'ᛁ',j:'ᛁ',k:'ᚴ',l:'ᛚ',m:'ᛘ',n:'ᚾ',o:'ᚢ',p:'ᛒ',q:'ᚴ',r:'ᚱ',s:'ᛋ',t:'ᛏ',u:'ᚢ',v:'ᚢ',w:'ᚢ',x:'ᚴᛋ',y:'ᛦ',z:'ᛦ' },
      di: { th:'ᚦ' }, name: 'Younger Futhark',
      row: [['f','ᚠ'],['u','ᚢ'],['th','ᚦ'],['a','ᚬ'],['r','ᚱ'],['k','ᚴ'],['h','ᚼ'],['n','ᚾ'],['i','ᛁ'],['a','ᛅ'],['s','ᛋ'],['t','ᛏ'],['b','ᛒ'],['m','ᛘ'],['l','ᛚ'],['y','ᛦ']]
    },
    anglo: {
      map: { a:'ᚪ',b:'ᛒ',c:'ᚳ',d:'ᛞ',e:'ᛖ',f:'ᚠ',g:'ᚷ',h:'ᚻ',i:'ᛁ',j:'ᛄ',k:'ᚳ',l:'ᛚ',m:'ᛗ',n:'ᚾ',o:'ᚩ',p:'ᛈ',q:'ᚳ',r:'ᚱ',s:'ᛋ',t:'ᛏ',u:'ᚢ',v:'ᚢ',w:'ᚹ',x:'ᛉ',y:'ᚣ',z:'ᛋ',æ:'ᚫ' },
      di: { th:'ᚦ', ng:'ᛝ' }, name: 'Anglo-Saxon Futhorc',
      row: [['f','ᚠ'],['u','ᚢ'],['th','ᚦ'],['o','ᚩ'],['r','ᚱ'],['c','ᚳ'],['g','ᚷ'],['w','ᚹ'],['h','ᚻ'],['n','ᚾ'],['i','ᛁ'],['j','ᛄ'],['p','ᛈ'],['x','ᛉ'],['s','ᛋ'],['t','ᛏ'],['b','ᛒ'],['e','ᛖ'],['m','ᛗ'],['l','ᛚ'],['ng','ᛝ'],['d','ᛞ'],['a','ᚪ'],['æ','ᚫ'],['y','ᚣ']]
    }
  };
  var ELDER = MAPS.elder.map;

  /* ---- Elder Futhark rune names + core meanings (standard) ---- */
  var MEANINGS = {
    'ᚠ':['Fehu','wealth'], 'ᚢ':['Uruz','strength'], 'ᚦ':['Thurisaz','defense'],
    'ᚨ':['Ansuz','wisdom'], 'ᚱ':['Raidho','journey'], 'ᚲ':['Kenaz','knowledge'],
    'ᚷ':['Gebo','gift'], 'ᚹ':['Wunjo','joy'], 'ᚺ':['Hagalaz','disruption'],
    'ᚾ':['Nauthiz','need'], 'ᛁ':['Isa','stillness'], 'ᛃ':['Jera','harvest'],
    'ᛇ':['Eihwaz','endurance'], 'ᛈ':['Perthro','fate'], 'ᛉ':['Algiz','protection'],
    'ᛋ':['Sowilo','success'], 'ᛏ':['Tiwaz','victory'], 'ᛒ':['Berkano','rebirth'],
    'ᛖ':['Ehwaz','trust'], 'ᛗ':['Mannaz','the self'], 'ᛚ':['Laguz','intuition'],
    'ᛜ':['Ingwaz','fertility'], 'ᛟ':['Othala','heritage'], 'ᛞ':['Dagaz','breakthrough']
  };
  /* English fallback; the section passes the localized article URL via data-vb-meanings-url (read in initTranslator) */
  var MEANINGS_URL = '/blogs/norse-news/elder-futhark-rune-meanings';

  /* ---- i18n: a translated page sets window.VB_RT_I18N (see sections/vb-rune-translator.liquid);
     every key falls back to the English text, so the English page is unchanged ---- */
  var I18N = window.VB_RT_I18N || {};
  function tr(k, en) { return (I18N[k] != null && I18N[k] !== '') ? I18N[k] : en; }
  var DEFAULT_PHRASE = tr('default_phrase', 'Wear your saga');
  MAPS.elder.name = tr('fk_elder', MAPS.elder.name);
  MAPS.younger.name = tr('fk_younger', MAPS.younger.name);
  MAPS.anglo.name = tr('fk_anglo', MAPS.anglo.name);
  if (I18N.meanings) Object.keys(MEANINGS).forEach(function (r) { if (I18N.meanings[r]) MEANINGS[r][1] = I18N.meanings[r]; });

  /* ---- transliterate (verbatim algorithm) ---- */
  function transliterate(raw, futhark, dir) {
    var fk = MAPS[futhark] || MAPS.elder;
    var out = '';
    if (dir === 'toText') {
      var rev = {};
      Object.keys(fk.map).forEach(function (lat) { var rune = fk.map[lat]; if (rev[rune] === undefined) rev[rune] = lat; });
      fk.row.forEach(function (pair) { rev[pair[1]] = pair[0]; });
      Object.keys(fk.di).forEach(function (dg) { rev[fk.di[dg]] = dg; });
      if (fk.rev) Object.keys(fk.rev).forEach(function (rune) { rev[rune] = fk.rev[rune]; });
      Array.from(raw).forEach(function (ch) { out += (rev[ch] !== undefined) ? rev[ch] : ch; });
    } else {
      /* German umlauts and ß have no rune of their own: spell them out the way they are pronounced */
      var src = raw.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
      /* Old Norse / Nordic letters likewise (Þórr, Søren, Åsa); æ keeps its own rune where the row has one (Futhorc ᚫ).
         Remaining accents (José) are stripped, so no Latin letter is left between the runes */
      src = src.replace(/[þð]/g, 'th').replace(/[øœ]/g, 'o').replace(/å/g, 'a');
      if (fk.map['æ'] === undefined) src = src.replace(/æ/g, 'ae');
      src = src.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      for (var i = 0; i < src.length; i++) {
        var two = src.substr(i, 2);
        if (fk.di[two]) { out += fk.di[two]; i++; continue; }
        var ch = src[i];
        out += (fk.map[ch] !== undefined) ? fk.map[ch] : ch;
      }
    }
    return out;
  }

  /* ---- bindrune: dedupe Elder runes ---- */
  function bindRuneList(input) {
    var seen = [];
    (input || '').toLowerCase().split('').forEach(function (ch) {
      if (ELDER[ch] && seen.indexOf(ELDER[ch]) === -1) seen.push(ELDER[ch]);
    });
    return seen.length ? seen : ['ᚠ'];
  }

  /* ---- bindrune stroke composer: runes as branch-strokes on ONE shared stave,
     paired left/right per level and stacked into a totem (the classic
     shared-stave construction — mirroring branches is traditional). ---- */
  var BIND_STROKES = {
    'ᚠ': [[[0,.30],[.5,.14]],[[0,.52],[.5,.36]]],
    'ᚢ': [[[0,0],[.5,.06],[.5,.95]]],
    'ᚦ': [[[0,.30],[.46,.5],[0,.70]]],
    'ᚨ': [[[0,.14],[.5,.30]],[[0,.36],[.5,.52]]],
    'ᚱ': [[[0,0],[.46,.18],[0,.36]],[[0,.36],[.48,.74]]],
    'ᚲ': [[[.46,.22],[0,.46],[.46,.70]]],
    'ᚷ': [[[-.24,.18],[.24,.82]],[[.24,.18],[-.24,.82]]],
    'ᚹ': [[[0,.04],[.46,.24],[0,.42]]],
    'ᚺ': [[[.5,.03],[.5,.97]],[[0,.42],[.5,.6]]],
    'ᚾ': [[[-.36,.34],[.36,.66]]],
    'ᛁ': [],
    'ᛃ': [[[0,.18],[.34,.34],[0,.5]],[[0,.5],[-.34,.66],[0,.82]]],
    'ᛇ': [[[0,.08],[.34,-.04]],[[0,.92],[-.34,1.04]]],
    'ᛈ': [[[.46,.16],[.12,.30],[.12,.70],[.46,.84]]],
    'ᛉ': [[[0,.42],[-.4,.04]],[[0,.42],[.4,.04]]],
    'ᛋ': [[[.30,.08],[-.10,.33],[.30,.58],[-.10,.83]]],
    'ᛏ': [[[-.36,.20],[0,0],[.36,.20]]],
    'ᛒ': [[[0,.05],[.46,.20],[0,.35]],[[0,.35],[.46,.5],[0,.65]]],
    'ᛖ': [[[.5,.08],[.5,.92]],[[0,.08],[.26,.42],[.5,.08]]],
    'ᛗ': [[[.5,.08],[.5,.92]],[[0,.08],[.5,.5]],[[.5,.08],[0,.5]]],
    'ᛚ': [[[0,.06],[.42,.30]]],
    'ᛜ': [[[0,.30],[.22,.5],[0,.70],[-.22,.5],[0,.30]]],
    'ᛟ': [[[0,.18],[.22,.40],[0,.62],[-.22,.40],[0,.18]],[[0,.62],[-.20,.92]],[[0,.62],[.20,.92]]],
    'ᛞ': [[[-.22,.18],[.22,.18],[-.22,.82],[.22,.82],[-.22,.18]]]
  };
  function bindPolylines(glyphs) {
    var W = 170, runeH = 80, arm = W * 0.40, cx = W / 2;
    /* strict pairs per level: first of the pair mirrored left, second right —
       the classic shared-stave layout */
    var gs = glyphs.filter(function (g) { return !!BIND_STROKES[g]; });
    if (!gs.length) gs = ['ᚠ'];
    var slots = [];
    for (var i = 0; i < gs.length; i += 2) slots.push(gs.slice(i, i + 2));
    var H = slots.length * runeH;
    var lines = [];
    function poly(pts, mirror, y0, y1) {
      return pts.map(function (p) { return [cx + (mirror ? -p[0] : p[0]) * arm, y0 + p[1] * (y1 - y0)]; });
    }
    lines.push(poly([[0, 0], [0, 1]], false, 0, H)); /* the shared stave */
    slots.forEach(function (slot, li) {
      /* measured from classic shared-stave marks: glyphs run ~23% taller than the
         level spacing, so neighbouring runes interlock along the stave */
      var yc = li * runeH + runeH / 2, half = runeH * 0.615;
      var y0 = yc - half, y1 = yc + half;
      slot.forEach(function (g, side) {
        BIND_STROKES[g].forEach(function (pl) { lines.push(poly(pl, side === 0, y0, y1)); });
      });
    });
    return { w: W, h: H, lines: lines, levels: slots.length };
  }
  function bindPathD(pl) {
    return pl.map(function (p, i) { return (i ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join(' ');
  }
  function bindSvgMarkup(glyphs, stroke, lw) {
    var bp = bindPolylines(glyphs);
    var m = 14;
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + (-m) + ' ' + (-m) + ' ' + (bp.w + 2 * m) + ' ' + (bp.h + 2 * m) + '">' +
      bp.lines.map(function (pl) {
        return '<path d="' + bindPathD(pl) + '" fill="none" stroke="' + stroke + '" stroke-width="' + (lw || 10) + '" stroke-linecap="square" stroke-linejoin="miter"/>';
      }).join('') + '</svg>';
  }
  function bindDrawCanvas(c, glyphs, x, y, availW, availH, color) {
    var bp = bindPolylines(glyphs);
    var s = Math.min(availW / bp.w, availH / bp.h);
    var ox = x + (availW - bp.w * s) / 2, oy = y + (availH - bp.h * s) / 2;
    c.strokeStyle = color; c.lineWidth = 10 * s; c.lineCap = 'square'; c.lineJoin = 'miter';
    bp.lines.forEach(function (pl) {
      c.beginPath();
      pl.forEach(function (p, i) { c[i ? 'lineTo' : 'moveTo'](ox + p[0] * s, oy + p[1] * s); });
      c.stroke();
    });
  }

  function accentColor() {
    try {
      var c = getComputedStyle(document.documentElement).getPropertyValue('--vb-accent').trim();
      if (c) return c;
    } catch (e) {}
    return '#8E2B22';
  }

  /* ================= poster renderer (multi-format, multi-design) ================= */
  var FORMATS = {
    card:      { w: 1200, h: 630,  label: 'Share card · 1200×630' },
    square:    { w: 1080, h: 1080, label: 'Square post · 1080×1080' },
    story:     { w: 1080, h: 1920, label: 'Story · 1080×1920' },
    wallpaper: { w: 1170, h: 2532, label: 'Phone wallpaper' },
    wall:      { w: 300, h: 375, label: '' } /* community-wall thumbnail; excluded from the size picker */
  };
  var DESIGNS = {
    stone:     { bg: '#1C1A17', bg2: '#141110', frame: '#3A2E1E', brand: '#9C8B6C', label: '#EDE4CE', rune: null /* accent */, foot: '#8E7A5C', name: 'Stone (dark)' },
    runestone: { photo: true, url: '', scrim: 'rgba(14,11,9,.50)', frame: 'rgba(216,188,142,.34)', brand: '#C9B48F', label: '#F1E7D2', rune: '#F1E7D2', foot: '#D8BC8E', name: 'Runestone (photo)' },
    forge:     { photo: true, url: '', scrim: 'rgba(12,9,7,.55)',  frame: 'rgba(216,188,142,.30)', brand: '#D8BC8E', label: '#F4E9CF', rune: '#F4E9CF', foot: '#D8BC8E', name: 'Forge (photo)' },
    parchment: { bg: '#F6F1E7', bg2: '#EDE4CE', frame: '#D8CBB6', brand: '#8a7c66', label: '#1C1A17', rune: '#8E2B22', foot: '#8a7c66', name: 'Parchment (light)' },
    ink:       { bg: null, bg2: null, frame: null, brand: null, label: '#111111', rune: '#111111', foot: '#9a9a9a', name: 'Ink · transparent (tattoo/print)' }
  };
  if (I18N.formats) Object.keys(I18N.formats).forEach(function (k) { if (FORMATS[k] && I18N.formats[k]) FORMATS[k].label = I18N.formats[k]; });
  if (I18N.designs) Object.keys(I18N.designs).forEach(function (k) { if (DESIGNS[k] && I18N.designs[k]) DESIGNS[k].name = I18N.designs[k]; });

  /* photo-background loader (CORS-enabled for canvas export) */
  var BG_CACHE = {};
  function loadBg(url) {
    return new Promise(function (resolve) {
      if (!url) return resolve(null);
      if (BG_CACHE[url]) return resolve(BG_CACHE[url] === 'err' ? null : BG_CACHE[url]);
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { BG_CACHE[url] = img; resolve(img); };
      img.onerror = function () { BG_CACHE[url] = 'err'; resolve(null); };
      img.src = url;
    });
  }
  function drawCover(c, img, W, H) {
    var ir = img.width / img.height, cr = W / H, dw, dh, dx, dy;
    if (ir > cr) { dh = H; dw = H * ir; dx = (W - dw) / 2; dy = 0; }
    else { dw = W; dh = W / ir; dx = 0; dy = (H - dh) / 2; }
    c.drawImage(img, dx, dy, dw, dh);
  }

  function wrapText(c, str, maxW) {
    var words = (str || '').split(' ');
    var lines = [], cur = '';
    for (var i = 0; i < words.length; i++) {
      var t = cur ? cur + ' ' + words[i] : words[i];
      if (c.measureText(t).width <= maxW || !cur) { cur = t; }
      else { lines.push(cur); cur = words[i]; }
    }
    if (cur) lines.push(cur);
    /* chunk any single line still too wide (long single word) */
    var out = [];
    lines.forEach(function (ln) {
      if (c.measureText(ln).width <= maxW) { out.push(ln); return; }
      var chunk = '';
      Array.from(ln).forEach(function (ch) {
        if (c.measureText(chunk + ch).width > maxW && chunk) { out.push(chunk); chunk = ch; }
        else chunk += ch;
      });
      if (chunk) out.push(chunk);
    });
    return out;
  }

  function renderPoster(text, runeStr, formatKey, designKey, bgImg) {
    var F = FORMATS[formatKey] || FORMATS.card;
    var D = DESIGNS[designKey] || DESIGNS.stone;
    var W = F.w, H = F.h, m = Math.min(W, H);
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var c = cv.getContext('2d');

    if (D.photo && bgImg) {
      drawCover(c, bgImg, W, H);
      c.fillStyle = D.scrim || 'rgba(12,10,9,.5)'; c.fillRect(0, 0, W, H);
    } else if (D.photo) {
      /* fallback if the photo did not load */
      var gp = c.createLinearGradient(0, 0, 0, H);
      gp.addColorStop(0, '#241f1b'); gp.addColorStop(1, '#141110');
      c.fillStyle = gp; c.fillRect(0, 0, W, H);
    } else if (D.bg) {
      var g = c.createLinearGradient(0, 0, 0, H);
      g.addColorStop(0, D.bg); g.addColorStop(1, D.bg2 || D.bg);
      c.fillStyle = g; c.fillRect(0, 0, W, H);
    }
    if (D.frame) {
      c.strokeStyle = D.frame; c.lineWidth = Math.max(2, m * 0.004);
      var inset = Math.round(m * 0.035);
      c.strokeRect(inset, inset, W - inset * 2, H - inset * 2);
    }
    c.textAlign = 'center'; c.textBaseline = 'middle';
    if (D.photo) { c.shadowColor = 'rgba(0,0,0,.6)'; c.shadowBlur = Math.round(m * 0.02); c.shadowOffsetY = Math.round(m * 0.005); }

    var runeColor = D.rune || accentColor();
    var portrait = H > W;
    var topY = portrait ? H * 0.10 : H * 0.13;
    var labelY = portrait ? H * 0.155 : H * 0.25;
    var footY = H - Math.max(34, H * 0.045);

    if (D.brand) {
      c.fillStyle = D.brand;
      c.font = '700 ' + Math.round(m * 0.026) + 'px Cinzel, serif';
      c.fillText('V I K I N G S B R A N D', W / 2, topY);
    }

    /* latin label */
    var label = (text || '').toUpperCase().trim();
    if (label) {
      c.fillStyle = D.label;
      var lfs = Math.round(m * 0.055);
      c.font = '600 ' + lfs + 'px Cinzel, serif';
      while (c.measureText(label).width > W * 0.82 && lfs > 18) { lfs -= 2; c.font = '600 ' + lfs + 'px Cinzel, serif'; }
      c.fillText(label, W / 2, labelY);
    }

    /* runes, wrapped + centered */
    c.fillStyle = runeColor;
    var rfs = Math.round(portrait ? m * 0.16 : m * 0.22);
    var maxW = W * 0.84, lines;
    while (true) {
      c.font = rfs + 'px "Noto Sans Runic", serif';
      lines = wrapText(c, runeStr, maxW);
      var block = lines.length * rfs * 1.18;
      var avail = portrait ? H * 0.50 : H * 0.40;
      if ((block <= avail && lines.length <= 6) || rfs <= 34) break;
      rfs -= 6;
    }
    var startY = H * (portrait ? 0.50 : 0.56) - ((lines.length - 1) * rfs * 1.18) / 2;
    lines.forEach(function (ln, i) { c.fillText(ln, W / 2, startY + i * rfs * 1.18); });

    /* footer */
    c.fillStyle = D.foot;
    c.font = Math.round(m * 0.020) + 'px Cinzel, serif';
    c.fillText(tr('poster_footer', 'Y O U R   N A M E   I N   R U N E S   ·   V I K I N G S B R A N D . C O'), W / 2, footY);

    return cv;
  }

  function downloadPoster(text, futhark, formatKey, designKey) {
    var runeStr = transliterate(text || DEFAULT_PHRASE, futhark, 'toRunes');
    var D = DESIGNS[designKey] || DESIGNS.stone;
    ensureRuneFont(function () {
      loadBg(D.photo ? D.url : '').then(function (img) {
        var cv = renderPoster(text, runeStr, formatKey, designKey, img);
        triggerPng(cv, 'vikingsbrand-runes-' + (formatKey || 'card') + '-' + (designKey || 'stone') + '.png');
      });
    });
  }

  /* ---- bindrune downloads (overlay on shared axis) ---- */
  function downloadBindrunePng(input, accent) {
    var runes = bindRuneList(input);
    var label = (input || '').toUpperCase();
    var W = 800, H = 1067;
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var c = cv.getContext('2d');
    c.fillStyle = '#1C1A17'; c.fillRect(0, 0, W, H);
    c.strokeStyle = '#3A2E1E'; c.lineWidth = 2; c.strokeRect(26, 26, W - 52, H - 52);
    c.textAlign = 'center'; c.textBaseline = 'middle';
    c.fillStyle = '#9C8B6C'; c.font = '700 24px Cinzel, serif'; c.fillText('V I K I N G S B R A N D', W / 2, 96);
    var done = function () {
      bindDrawCanvas(c, runes, 120, 150, W - 240, H - 420, accent);
      c.fillStyle = '#EDE4CE'; c.font = '700 40px Cinzel, serif'; c.fillText(label, W / 2, H - 150);
      c.strokeStyle = '#4A3C26'; c.lineWidth = 2; c.beginPath(); c.moveTo(W / 2 - 26, H - 110); c.lineTo(W / 2 + 26, H - 110); c.stroke();
      c.fillStyle = '#8E7A5C'; c.font = '22px Archivo, sans-serif'; c.fillText('VIKINGSBRAND.CO', W / 2, H - 74);
      triggerPng(cv, 'vikingsbrand-bindrune-' + (label.toLowerCase() || 'rune') + '.png');
    };
    ensureRuneFont(done);
  }

  function downloadBindruneSvg(input, accent) {
    var runes = bindRuneList(input);
    var label = (input || '').toUpperCase();
    var W = 800, H = 1067, cx = W / 2;
    var bp = bindPolylines(runes);
    var availW = W - 240, availH = H - 420;
    var s = Math.min(availW / bp.w, availH / bp.h);
    var ox = 120 + (availW - bp.w * s) / 2, oy = 150 + (availH - bp.h * s) / 2;
    var glyph = '<g transform="translate(' + ox.toFixed(1) + ' ' + oy.toFixed(1) + ') scale(' + s.toFixed(3) + ')">' +
      bp.lines.map(function (pl) {
        return '<path d="' + bindPathD(pl) + '" fill="none" stroke="' + accent + '" stroke-width="10" stroke-linecap="square" stroke-linejoin="miter"/>';
      }).join('') + '</g>';
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + W + '" height="' + H + '" viewBox="0 0 ' + W + ' ' + H + '">' +
      '<rect width="' + W + '" height="' + H + '" fill="#1C1A17"/>' +
      '<rect x="26" y="26" width="' + (W - 52) + '" height="' + (H - 52) + '" fill="none" stroke="#3A2E1E" stroke-width="2"/>' +
      '<text x="' + cx + '" y="96" fill="#9C8B6C" font-family="Cinzel, serif" font-weight="700" font-size="24" letter-spacing="8" text-anchor="middle">VIKINGSBRAND</text>' +
      glyph +
      '<text x="' + cx + '" y="' + (H - 150) + '" fill="#EDE4CE" font-family="Cinzel, serif" font-weight="700" font-size="40" letter-spacing="4" text-anchor="middle">' + label + '</text>' +
      '<line x1="' + (cx - 26) + '" y1="' + (H - 110) + '" x2="' + (cx + 26) + '" y2="' + (H - 110) + '" stroke="#4A3C26" stroke-width="2"/>' +
      '<text x="' + cx + '" y="' + (H - 70) + '" fill="#8E7A5C" font-family="Archivo, sans-serif" font-size="22" letter-spacing="6" text-anchor="middle">VIKINGSBRAND.CO</text>' +
      '</svg>';
    var blob = new Blob([svg], { type: 'image/svg+xml' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob); a.download = 'vikingsbrand-bindrune-' + (label.toLowerCase() || 'rune') + '.svg';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
  }

  function ensureRuneFont(cb) {
    try {
      if (document.fonts && document.fonts.load) {
        Promise.all([
          document.fonts.load('300px "Noto Sans Runic"'),
          document.fonts.load('700 24px Cinzel')
        ]).then(function () { return document.fonts.ready; }).then(cb).catch(cb);
        return;
      }
    } catch (e) {}
    cb();
  }
  function triggerPng(cv, name) {
    var a = document.createElement('a');
    a.href = cv.toDataURL('image/png'); a.download = name;
    document.body.appendChild(a); a.click(); a.remove();
  }

  /* lightweight usage tracking: fires to whatever analytics is already on the page (GA4 / GTM dataLayer / Shopify).
     No-op and never throws if no analytics is present. Real, honest counts, visible to the store owner only. */
  function vbTrack(action, extra) {
    try {
      var d = { tool: 'rune-translator', vb_action: action };
      if (extra) { if (extra.futhark) d.futhark = extra.futhark; if (extra.design) d.design = extra.design; if (extra.format) d.format = extra.format; }
      if (window.gtag) window.gtag('event', 'rune_' + action, d);
      if (window.dataLayer && window.dataLayer.push) { var g = { event: 'rune_' + action }; for (var k in d) g[k] = d[k]; window.dataLayer.push(g); }
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('rune_' + action, d);
    } catch (e) {}
  }

  /* ---- DOM wiring ---- */
  function refChart(fk) {
    return fk.row.map(function (p) {
      return '<div class="vb-rune-cell"><span class="vb-rune-glyph">' + p[1] + '</span><span class="vb-rune-letter">' + p[0] + '</span></div>';
    }).join('');
  }

  function meaningsHtml(runeStr) {
    var seen = [], chips = '';
    Array.from(runeStr || '').forEach(function (ch) {
      if (MEANINGS[ch] && seen.indexOf(ch) === -1) seen.push(ch);
    });
    if (!seen.length) return '';
    seen.forEach(function (ch) {
      var m = MEANINGS[ch];
      chips += '<a class="vb-meaning-chip" href="' + MEANINGS_URL + '" title="' + m[0] + ', ' + m[1] + '">' +
        '<span class="vb-meaning-glyph">' + ch + '</span><span class="vb-meaning-txt"><strong>' + m[0] + '</strong> ' + m[1] + '</span></a>';
    });
    return '<div class="vb-meanings-head">' + tr('meanings_head', 'What your runes mean') + '</div><div class="vb-meanings-row">' + chips + '</div>' +
      '<a class="vb-meanings-link" href="' + MEANINGS_URL + '">' + tr('meanings_link', 'Full Elder Futhark rune meanings guide →') + '</a>';
  }

  function initTranslator(root) {
    var state = { futhark: 'elder', dir: 'toRunes', input: DEFAULT_PHRASE, format: 'square', design: 'stone' };
    if (root.getAttribute('data-vb-meanings-url')) MEANINGS_URL = root.getAttribute('data-vb-meanings-url');
    var currentCanvas = null, previewTimer = null, tracked = false;
    var input = root.querySelector('[data-vb="trans-input"]');
    var output = root.querySelector('[data-vb="trans-output"]');
    var chart = root.querySelector('[data-vb="trans-chart"]');
    var chartName = root.querySelector('[data-vb="trans-chart-name"]');
    var tabs = root.querySelectorAll('[data-vb-futhark]');
    var dirBtns = root.querySelectorAll('[data-vb-dir]');
    var copyBtn = root.querySelector('[data-vb="trans-copy"]');
    var dlBtn = root.querySelector('[data-vb="trans-download"]');
    var fmtSel = root.querySelector('[data-vb="dl-format"]');
    var swatchWrap = root.querySelector('[data-vb="design-swatches"]');
    var previewEl = root.querySelector('[data-vb="poster-preview"]');
    var meanings = root.querySelector('[data-vb="rune-meanings"]');
    var shareBtn = root.querySelector('[data-vb="trans-share"]');
    var wallEl = root.querySelector('[data-vb="rune-wall"]');
    var wallWrap = root.querySelector('[data-vb="rune-wall-wrap"]');
    var wallEndpoint = (root.getAttribute('data-vb-wall-endpoint') || '').replace(/\/+$/, '');
    var wallItems = [];

    /* photo-design background urls from data attributes (theme asset_url) */
    if (DESIGNS.runestone) DESIGNS.runestone.url = root.getAttribute('data-vb-bg-runestone') || '';
    if (DESIGNS.forge) DESIGNS.forge.url = root.getAttribute('data-vb-bg-forge') || '';
    loadBg(DESIGNS.runestone && DESIGNS.runestone.url); loadBg(DESIGNS.forge && DESIGNS.forge.url); /* warm cache */

    /* populate pickers if present */
    if (fmtSel && !fmtSel.options.length) {
      Object.keys(FORMATS).forEach(function (k) {
        if (k === 'wall') return; /* thumbnail format, not a user-selectable poster size */
        var o = document.createElement('option'); o.value = k; o.textContent = FORMATS[k].label; fmtSel.appendChild(o);
      });
    }
    if (fmtSel) fmtSel.value = state.format;
    /* background chooser: one swatch per design (skip photo designs with no image) */
    if (swatchWrap && !swatchWrap.children.length) {
      Object.keys(DESIGNS).forEach(function (k) {
        var D = DESIGNS[k];
        if (D.photo && !D.url) return;
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'vb-swatch';
        btn.setAttribute('data-vb-design', k);
        btn.setAttribute('aria-pressed', k === state.design ? 'true' : 'false');
        btn.title = D.name;
        var tile = document.createElement('span'); tile.className = 'vb-swatch__tile';
        if (D.photo && D.url) { tile.style.backgroundImage = 'url("' + D.url + '")'; }
        else if (D.bg) { tile.style.background = D.bg; }
        else { tile.className += ' is-transparent'; }
        var nm = document.createElement('span'); nm.className = 'vb-swatch__name';
        nm.textContent = D.name.split('(')[0].split('·')[0].trim();
        btn.appendChild(tile); btn.appendChild(nm);
        btn.addEventListener('click', function () {
          state.design = k;
          swatchWrap.querySelectorAll('.vb-swatch').forEach(function (s) {
            s.setAttribute('aria-pressed', s.getAttribute('data-vb-design') === k ? 'true' : 'false');
          });
          renderPreview();
        });
        swatchWrap.appendChild(btn);
      });
    }

    function renderPreview() {
      if (!previewEl) return;
      var text = state.input;
      var runeStr = transliterate(text || DEFAULT_PHRASE, state.futhark, 'toRunes');
      var D = DESIGNS[state.design] || DESIGNS.stone;
      /* transparent (ink) design: show a checkerboard behind so black runes stay visible and the transparency is obvious */
      previewEl.classList.toggle('is-transparent-bg', !D.photo && !D.bg);
      ensureRuneFont(function () {
        loadBg(D.photo ? D.url : '').then(function (img) {
          var cv = renderPoster(text, runeStr, state.format, state.design, img);
          currentCanvas = cv;
          previewEl.innerHTML = '';
          previewEl.appendChild(cv);
          previewEl.classList.remove('is-empty');
        });
      });
    }
    function schedulePreview() { clearTimeout(previewTimer); previewTimer = setTimeout(renderPreview, 160); }
    if (fmtSel) fmtSel.addEventListener('change', function () { state.format = fmtSel.value; renderPreview(); });

    function render() {
      var fk = MAPS[state.futhark];
      if (input && input.value !== state.input) input.value = state.input;
      var out = transliterate(state.input, state.futhark, state.dir) || '…';
      if (output) {
        output.textContent = out;
        output.style.fontFamily = state.dir === 'toRunes' ? "'Noto Sans Runic', serif" : "'Alegreya', serif";
      }
      if (input) input.style.fontFamily = state.dir === 'toRunes' ? "'Archivo', sans-serif" : "'Noto Sans Runic', serif";
      if (chart) chart.innerHTML = refChart(fk);
      if (chartName) chartName.textContent = fk.name;
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-vb-futhark') === state.futhark); });
      dirBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-vb-dir') === state.dir); });
      /* meanings legend: Elder text→runes only (names/meanings are Elder Futhark) */
      if (meanings) {
        if (state.dir === 'toRunes' && state.futhark === 'elder') {
          meanings.innerHTML = meaningsHtml(out);
          meanings.style.display = meanings.innerHTML ? '' : 'none';
        } else { meanings.innerHTML = ''; meanings.style.display = 'none'; }
      }
      schedulePreview();
    }
    if (input) input.addEventListener('input', function (e) {
      state.input = e.target.value;
      if (!tracked && state.input.trim()) { tracked = true; vbTrack('translate', { futhark: state.futhark }); }
      render();
    });
    tabs.forEach(function (t) { t.addEventListener('click', function () { state.futhark = t.getAttribute('data-vb-futhark'); render(); }); });
    dirBtns.forEach(function (b) { b.addEventListener('click', function () {
      state.dir = b.getAttribute('data-vb-dir');
      state.input = state.dir === 'toRunes' ? DEFAULT_PHRASE : transliterate(DEFAULT_PHRASE, 'elder', 'toRunes');
      render();
    }); });
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var out = transliterate(state.input, state.futhark, state.dir);
      var flip = function () { copyBtn.textContent = tr('copied', 'COPIED ✓'); setTimeout(function () { copyBtn.textContent = tr('copy', 'COPY'); }, 1600); };
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(out).then(flip, function () {}); }
        else { flip(); }
      } catch (e) {}
      vbTrack('copy', { futhark: state.futhark });
    });
    if (dlBtn) dlBtn.addEventListener('click', function () {
      var name = 'vikingsbrand-runes-' + state.format + '-' + state.design + '.png';
      if (currentCanvas) { triggerPng(currentCanvas, name); }
      else { downloadPoster(state.input, state.futhark, state.format, state.design); }
      vbTrack('download', { format: state.format, design: state.design, futhark: state.futhark });
    });

    /* ---------- community wall: opt-in + moderated; backend URL from data-vb-wall-endpoint (blank => hidden) ---------- */
    function validShare(t) { return !!t && t.length <= 24 && /^[\p{L}][\p{L} .'\-]*$/u.test(t); }

    function wallToast(msg) {
      var host = wallWrap || (previewEl && previewEl.parentNode);
      if (!host) return;
      var el = document.createElement('div'); el.className = 'vb-wall-toast'; el.textContent = msg;
      host.appendChild(el);
      setTimeout(function () { el.classList.add('is-out'); }, 2200);
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 2700);
    }

    function wallThumb(item) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'vb-wall-item'; btn.title = item.text;
      var img = document.createElement('img'); img.alt = item.text + ' written in Norse runes'; img.loading = 'lazy';
      btn.appendChild(img);
      var runeStr = transliterate(item.text, item.futhark || 'elder', 'toRunes');
      var D = DESIGNS[item.design] || DESIGNS.stone;
      btn._ready = loadBg(D.photo ? D.url : '').then(function (bg) {
        try { img.src = renderPoster(item.text, runeStr, 'wall', item.design, bg).toDataURL('image/png'); } catch (e) {}
      });
      btn.addEventListener('click', function () {
        state.input = item.text; state.futhark = item.futhark || 'elder'; state.design = item.design || 'stone';
        if (input) input.value = state.input;
        if (swatchWrap) swatchWrap.querySelectorAll('.vb-swatch').forEach(function (s) {
          s.setAttribute('aria-pressed', s.getAttribute('data-vb-design') === state.design ? 'true' : 'false');
        });
        render();
        if (previewEl && previewEl.scrollIntoView) previewEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      return btn;
    }

    function renderWall() {
      if (!wallEl) return;
      var list = wallItems.filter(function (it) { return it && it.text; }).slice(0, 30);
      if (!list.length) { if (wallWrap) wallWrap.style.display = 'none'; return; }
      if (wallWrap) wallWrap.style.display = '';
      ensureRuneFont(function () {
        var track = document.createElement('div'); track.className = 'vb-wall-track';
        var nodes = list.map(function (it) { var n = wallThumb(it); track.appendChild(n); return n; });
        wallEl.innerHTML = ''; wallEl.appendChild(track);
        /* seamless marquee once thumbs are drawn: duplicate the row and animate (only if enough to overflow) */
        if (list.length >= 6) {
          Promise.all(nodes.map(function (n) { return n._ready; })).then(function () {
            nodes.forEach(function (n) { var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.tabIndex = -1; track.appendChild(c); });
            track.style.animationDuration = Math.max(24, list.length * 3.2) + 's';
            track.classList.add('is-marquee');
          });
        }
      });
    }

    function loadWall() {
      if (!wallEndpoint || !wallEl) { if (wallWrap) wallWrap.style.display = 'none'; return; }
      fetch(wallEndpoint + '/feed').then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
        wallItems = (data && data.items) ? data.items : (Array.isArray(data) ? data : []);
        renderWall();
      }).catch(function () { if (wallWrap) wallWrap.style.display = 'none'; });
    }

    function shareCurrent() {
      if (!wallEndpoint || !shareBtn) return;
      var text = (state.input || '').trim();
      if (!validShare(text)) { wallToast(tr('toast_need_text', 'Type a name or word first (letters only).')); return; }
      var old = shareBtn.textContent; shareBtn.disabled = true; shareBtn.textContent = tr('sharing', 'SHARING…');
      fetch(wallEndpoint + '/submit', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: text, futhark: state.futhark, design: state.design })
      }).then(function (r) { return r.json().catch(function () { return {}; }); }).then(function (res) {
        shareBtn.disabled = false; shareBtn.textContent = old;
        if (res && res.ok === false) { wallToast(res.error || tr('toast_fail', 'That could not be shared.')); return; }
        wallToast(tr('toast_shared', 'Shared to the wall ✓')); vbTrack('share', { design: state.design, futhark: state.futhark });
        wallItems.unshift({ text: text, futhark: state.futhark, design: state.design }); renderWall();
      }).catch(function () { shareBtn.disabled = false; shareBtn.textContent = old; wallToast(tr('toast_network', 'Network error, please try again.')); });
    }

    if (shareBtn) { if (wallEndpoint) shareBtn.addEventListener('click', shareCurrent); else shareBtn.style.display = 'none'; }
    if (wallEndpoint) loadWall(); else if (wallWrap) wallWrap.style.display = 'none';

    render();
  }

  function initBindrune(root) {
    var state = { input: 'VB' };
    var input = root.querySelector('[data-vb="bind-input"]');
    var preview = root.querySelector('[data-vb="bind-preview"]');
    var label = root.querySelector('[data-vb="bind-label"]');
    var pngBtn = root.querySelector('[data-vb="bind-png"]');
    var svgBtn = root.querySelector('[data-vb="bind-svg"]');

    function render() {
      var runes = bindRuneList(state.input);
      if (input && input.value !== state.input) input.value = state.input;
      if (preview) {
        preview.innerHTML = bindSvgMarkup(runes, 'currentColor', 10);
        var sv = preview.querySelector('svg');
        if (sv) { sv.style.height = Math.min(420, 100 + bindPolylines(runes).levels * 88) + 'px'; sv.style.width = 'auto'; sv.style.display = 'block'; sv.style.margin = '0 auto'; }
      }
      if (label) label.textContent = (state.input || '').trim() || tr('your_mark', 'Your mark');
    }
    if (input) input.addEventListener('input', function (e) { state.input = e.target.value; render(); });
    if (pngBtn) pngBtn.addEventListener('click', function () { downloadBindrunePng(state.input, accentColor()); });
    if (svgBtn) svgBtn.addEventListener('click', function () { downloadBindruneSvg(state.input, accentColor()); });
    render();
  }

  function boot() {
    var t = document.getElementById('vb-translator'); if (t) initTranslator(t);
    var b = document.getElementById('vb-bindrune'); if (b) initBindrune(b);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* expose for tests */
  window.VBRunes = { transliterate: transliterate, bindRuneList: bindRuneList, MAPS: MAPS, MEANINGS: MEANINGS,
    FORMATS: FORMATS, DESIGNS: DESIGNS, renderPoster: renderPoster, downloadPoster: downloadPoster,
    downloadBindrunePng: downloadBindrunePng, downloadBindruneSvg: downloadBindruneSvg };
})();
